import { CsvValidationException } from '@/components/Analysis/Idms/types';
import { BulkUploadPoisInput } from '@/__generated__/graphql';
import { atom } from 'jotai';

export const bulkUploadModal = atom<'closed' | 'upload' | 'confirm' | 'invalid_format' | 'invalid_data' | 'validation'>(
  'closed'
);

export const errors = atom<CsvValidationException | undefined>(undefined);

export const uploadInput = atom<BulkUploadPoisInput | undefined>(undefined);

export const fileData = atom<File | null>(null);
